import { hc } from 'hono/client';
var client = hc('');
export var hcWithType = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return hc.apply(void 0, args);
};
